var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"olympiad-banner"},[_c('h1',[_vm._v("онлайн-олимпиады")]),_vm._v(" "),_c('h2',[_vm._v("проверяйте свои знания и выигрывайте ценные призы!")])])
}]

export { render, staticRenderFns }